<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1800px; padding-top: 100px">
                    <div class="breadcrumb-new">
                        <a href="/dashboard">Личный кабинет</a>
                        <span>›</span>
                        <span>Страховые продукты</span>
                    </div>
                    <div class="top-row">
                        <h1 class="page-title">Страховые <span>продукты</span></h1>

                        <div class="reward-badge" v-if="showCommissions">
                            <span class="reward-label">Общее вознаграждение</span>
                            <div
                                v-if="isRewardLoading"
                                class="reward-loading-hint"
                            >
                                <v-progress-circular
                                    indeterminate
                                    size="18"
                                    width="2"
                                    color="#00BA57"
                                />
                            </div>
                            <div class="reward-amount" v-else>
                                <span>{{ formatNumber(commissionByMonth) }}</span>
                                <span class="currency">₽</span>
                            </div>
                            <div class="month-note">
                                <osago-month
                                    :value="commissionByMonth"
                                    :variant="true"
                                    @change="balanceDateChanged"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="control-bar">
                        <div class="search-cluster">
                            <div class="text-search">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Поиск по ФИО, телефону, e-mail..."
                                    v-model="filters.search"
                                    @keydown.enter.prevent="newSearch"
                                >
                            </div>
                        </div>

                        <div class="btn-cluster">
                            <button class="btn btn-outline btn-search-width" @click.prevent="newSearch">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                </svg>
                                Поиск
                            </button>

                            <div class="products-btn-wrap">
                                <button class="btn btn-primary" @click.prevent="toDisplay = true">
                                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                        <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                                    </svg>
                                    Новый полис
                                </button>
                                <a href="/bp/list" target="_blank" class="products-link" v-if="role === 'admin'">Банковские продукты →</a>
                            </div>
                        </div>

                        <b2b-policy-type-dialog
                            :links="policyTypesArray"
                            :hideButton="true"
                            :toDisplay="toDisplay"
                            @changeDialog="changeDialog"
                        ></b2b-policy-type-dialog>
                    </div>
                </v-container>

                <v-container style="max-width: 1800px;">
                    <div class="policy-list-table mb-5">
                        <div class="filters-block">
                            <div class="filters-block__header" @click="showFilters">
                                <h3 class="py-0">Фильтры</h3>
                                <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": panel.length }'>
                                    expand_more
                                </v-icon>
                            </div>
                            <v-expansion-panel v-model="panel" expand>
                                <v-expansion-panel-content>
                                    <div class="filters-block__body">
                                        <v-layout py-0 pt-3 row wrap class="filters">
                                            <v-flex xs12 sm6 py0 v-if="showCurators">
                                                <v-autocomplete
                                                    v-model="filters.curator"
                                                    :items="curatorsList"
                                                    :loading="isLoadingCuratorsFilter"
                                                    label="Куратор"
                                                    :search-input.sync="filters.curatorSearch"
                                                    item-value="id"
                                                    item-text="name"
                                                    multiple
                                                    chips
                                                    deletable-chips
                                                    :allow-overflow=false
                                                    :hide-details="true"
                                                    @focus="onCuratorFocus"
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                    Не найдено: "<strong>{{ filters.curatorSearch }}</strong>".
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 py0 v-if="showAgents">
                                                <v-autocomplete
                                                    v-model="filters.agent"
                                                    :items="agentsList"
                                                    :loading="isLoadingAgentsFilter"
                                                    label="Пользователь"
                                                    :search-input.sync="filters.agentSearch"
                                                    item-value="id"
                                                    item-text="name"
                                                    multiple
                                                    chips
                                                    deletable-chips
                                                    :allow-overflow=false
                                                    :hide-details="true"
                                                    @focus="onAgentFocus"
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                    Не найдено: "<strong>{{ filters.agentSearch }}</strong>".
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 py0 v-if="showOperators">
                                                <v-autocomplete
                                                    v-model="filters.operator"
                                                    :items="operatorsList"
                                                    :loading="isLoadingOperatorsFilter"
                                                    label="Сотрудник"
                                                    :search-input.sync="filters.operatorSearch"
                                                    item-value="id"
                                                    item-text="name"
                                                    multiple
                                                    chips
                                                    deletable-chips
                                                    :allow-overflow=false
                                                    :hide-details="true"
                                                    @focus="onOperatorFocus"
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                    Не найдено: "<strong>{{ filters.operatorSearch }}</strong>".
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 py0
                                                    :class="role === 'admin' ? 'sm4' : 'sm6'"
                                                    v-if="role === 'admin' || !filters.is_egarant">
                                                <v-autocomplete
                                                    v-model="filters.company"
                                                    :items="filters.is_egarant ? egarantCompaniesList : companiesList"
                                                    label="Страховая компания"
                                                    :search-input.sync="filters.companySearch"
                                                    item-value='alias'
                                                    item-text='name'
                                                    :allow-overflow=false
                                                    :hide-details="true"
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                    Не найдено: "<strong>{{ filters.companySearch }}</strong>".
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm2 py0
                                                    v-if="role === 'admin'">
                                                <v-checkbox
                                                    v-model="filters.is_egarant"
                                                    label="Е-Гарант"
                                                    @change="isEgarantChanged"
                                                />
                                            </v-flex>
                                        </v-layout>

                                        <v-layout py-0 row wrap class="filters">
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Оформлен, от"
                                                    v-model="filters.date_from"
                                                    :yearStarting="false"
                                                    :max="filters.date_to"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Оформлен, до"
                                                    v-model="filters.date_to"
                                                    :yearStarting="false"
                                                    :min="filters.date_from"
                                                    :isRequired="false"
                                                />
                                            </v-flex>

                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Дата начала, от"
                                                    v-model="filters.beg_date_from"
                                                    :yearStarting="false"
                                                    :max="filters.beg_date_to"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Дата начала, до"
                                                    v-model="filters.beg_date_to"
                                                    :yearStarting="false"
                                                    :min="filters.beg_date_from"
                                                    :isRequired="false"
                                                />
                                            </v-flex>

                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Дата окончания, от"
                                                    v-model="filters.end_date_from"
                                                    :yearStarting="false"
                                                    :max="filters.end_date_to"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <osago-date
                                                    label="Дата окончания, до"
                                                    v-model="filters.end_date_to"
                                                    :yearStarting="false"
                                                    :min="filters.end_date_from"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                        </v-layout>

                                        <v-layout py-0 row wrap class="filters">
                                            <v-flex v-if="showSegment" xs12 sm6 md3 lg2 py0>
                                                <v-select
                                                    v-model="filters.segment"
                                                    :items="segmentsList"
                                                    label="Канал продаж"
                                                    item-value='id'
                                                    item-text='name'
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <v-select
                                                    v-model="filters.policy_type"
                                                    :items="typesList"
                                                    label="Тип полиса"
                                                    item-value='id'
                                                    item-text='name'
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                    class="policy-type-select"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0 v-if="role === 'admin' || role === 'curator'">
                                                <v-autocomplete
                                                    v-model="filters.region"
                                                    :items="regionsList"
                                                    label="Регион"
                                                    :search-input.sync="filters.regionSearch"
                                                    item-text="name_with_type"
                                                >
                                                    <template v-slot:no-data>
                                                        <v-list-tile>
                                                            <v-list-tile-content>
                                                                <v-list-tile-title>
                                                                    Не найдено: "<strong>{{ filters.operatorSearch }}</strong>".
                                                                </v-list-tile-title>
                                                            </v-list-tile-content>
                                                        </v-list-tile>
                                                    </template>
                                                </v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <v-select
                                                    v-model="filters.is_pull"
                                                    :items="IsPullTypesList"
                                                    label="Пул"
                                                    item-value='id'
                                                    item-text='name'
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <v-select
                                                    v-model="filters.is_cross_sale"
                                                    :items="crossSaleList"
                                                    label="Продажа кросс"
                                                    item-value='id'
                                                    item-text='name'
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs12 sm6 md3 lg2 py0>
                                                <v-select
                                                    v-model="filters.usage_purpose"
                                                    :items="usagePurposeList"
                                                    label="Цель использования"
                                                    item-value='id'
                                                    item-text='name'
                                                    :menu-props="{ bottom: true, offsetY: true }"
                                                ></v-select>
                                            </v-flex>
                                        </v-layout>

                                        <v-layout>
                                            <v-flex xs6 sm8 md9 lg10>
                                                <a @click="cleanFilters" class="link">Очистить фильтры</a>
                                            </v-flex>
                                        </v-layout>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </div>
                    </div>

                    <div class="policy-list-table">
                        <div class="policy-list-table__header pb-3">
                            <v-tabs
                                v-model="tab"
                                slider-color="#000"
                                show-arrows
                            >
                                <v-tab v-for="(tab, index) in tabsList" :key="index"
                                       :class="[index === 4 && prolongCount ? 'with-count' : '']"
                                       @click="changeTab(index)"
                                >
                                    {{ tab }}
                                    <span v-if="index === 4 && prolongCount" class="with-count__num">{{ prolongCount }}</span>
                                </v-tab>
                            </v-tabs>
                            <div
                                v-if="isProlong"
                                class="download-excel-button"
                            >
                                <download-excel
                                    class="d-inline-block"
                                    name="policy-list.xls"
                                    worksheet="Полисы"
                                    :fetch="downloadItems"
                                    :fields="isProlong ? prolongDownloadFields : downloadFields "
                                >
                                </download-excel>
                            </div>
                            <div
                                v-else
                                class="download-excel-button"
                            >
                                <v-tooltip bottom>
                                    <template #activator="{ on, attrs }">
                                        <v-btn
                                            flat
                                            icon
                                            color="#00ba57"
                                            v-bind="attrs"
                                            v-on="on"
                                            @click="downloadExport"
                                        >
                                            <v-icon medium>arrow_circle_down</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Выгрузить результат</span>
                                </v-tooltip>
                            </div>
                            <div>
                                <v-menu
                                    v-if="!isProlong"
                                    class="d-inline-block"
                                    d-inline
                                    :close-on-content-click="false"
                                    offset-x
                                    allow-overflow
                                    :left="true"
                                >
                                    <template #activator="{ on: menu }">
                                        <v-tooltip bottom>
                                            <template #activator="{ on: tooltip }">
                                                <v-btn
                                                    icon
                                                    v-on="{ ...tooltip, ...menu }"
                                                >
                                                    <v-icon>settings</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Управление колонками</span>
                                        </v-tooltip>
                                    </template>

                                    <v-list>
                                        <v-list-tile
                                            v-for="(item) in toggleableColumns"
                                            :key="item.id"
                                        >
                                            <v-list-tile-action>
                                                <v-checkbox
                                                    class="mh-0-important"
                                                    :input-value="shownToggleableColumns[item.id]"
                                                    @change="toggleColumn($event, item.id)"
                                                />
                                            </v-list-tile-action>
                                            <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </div>
                        </div>
                        <div class="policy-list-table__body">
                            <v-data-table
                                py-5
                                ref="policyListTable"
                                v-model="selected"
                                :headers="activeHeaders"
                                :items="rows"
                                :pagination.sync="pagination"
                                :total-items="totalRows"
                                :loading="loading"
                                item-key="1"
                                :rows-per-page-items="[10,25,50]"
                                rows-per-page-text="Показывать по"
                                select-all
                                no-data-text="Нет данных"
                                no-results-text="Ничего не найдено"
                            >
                                <template v-slot:no-results>
                                    <v-layout py-5>
                                        <p>Ничего не найдено. <a @click="cleanFilters">Очистить фильтры</a></p>
                                    </v-layout>
                                </template>
                                <template v-slot:headers="props">
                                    <tr>
                                        <th v-if="!isProlongShow || !isTermination">
                                            <v-checkbox
                                                :input-value="props.all"
                                                :indeterminate="props.indeterminate"
                                                primary
                                                hide-details
                                                @click.stop="toggleAll"
                                            ></v-checkbox>
                                        </th>
                                        <template v-for="header in props.headers">
                                        <th
                                            v-if="!header.toggleable || (header.toggleable && shownToggleableColumns[header.value])"
                                            :key="header.text"
                                            :class="[
                                        'column text-xs-left',
                                        pagination.descending ? 'desc' : 'asc',
                                        header.sortable === false ? '' : 'sortable',
                                        header.value === pagination.sortBy ? 'active' : ''
                                    ]"
                                            :style="{
                                        minWidth: header.width ? `${header.width}px`: 'auto',
                                        width: header.maxWidth ? `${header.maxWidth}px`: 'auto',
                                        paddingLeft: '10px',
                                        paddingRight: '10px',
                                    }"
                                            @click="header.sortable !== false && changeSort(header.value)"
                                        >
                                            {{ header.text }}
                                            <v-icon v-if="header.sortable !== false" small>arrow_upward</v-icon>
                                        </th>
                                        </template>
                                    </tr>
                                </template>
                                <template v-slot:items="props" v-if="isProlong">
                                    <tr :class="[props.item['prolong_next_call_date'] ? '' : 'not-active', 'prolongation-table']"
                                        @click="showMenu($event, props.item)"
                                    >
                                        <td>
                                            <v-checkbox
                                                v-model="selected[props.item.prolong_id]"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <td>{{ props.item['curator_name'] || '—' }}<br>{{ props.item['curator_email'] }}</td>
                                        <td>{{ props.item['agent_name'] || '—' }}<br>{{ props.item['agent_email'] || '—' }}</td>
                                        <td>{{ props.item['operator_name'] || '—' }}<br>{{ props.item['operator_name'] || '—' }}
                                        </td>
                                        <td>{{
                                                props.item['prev_order_insurer_name']
                                            }}<br>{{
                                                props.item['prev_order_insurer_phone']
                                            }}<br>{{ props.item['prev_order_insurer_email'] }}
                                        </td>
                                        <td>{{ props.item['order_product'] === 'Транзит' ? 'ОСАГО не РФ' : props.item['order_product'] || '—' }}</td>
                                        <td>{{ props.item['prev_order_end_date'] || '—' }}</td>
                                        <td
                                            @click.stop="getCurrentDate(props.item['prolong_id'])"
                                        >
                                            <osago-date
                                                inputClass="pt-0"
                                                label="Введите дату"
                                                v-model="props.item['next_call_date']"
                                                :min="currentDate"
                                                :yearStarting="false"
                                                :isRequired="selectedProlongId === props.item['prolong_id'] && props.item['next_call_date']"
                                                :isCallDate="true"
                                                @change="dataStartChanged(props.item)"
                                            />
                                        </td>
                                        <td class="ins-logo-container"> <!-- Лого компании -->
                                            <img class="ins-logo"
                                                 :src="props.item['company_logo']"/>
                                            {{ props.item['company_logo'] ? '' : props.item['company_name'] }}
                                        </td>
                                        <td>{{ props.item['prev_order_process_premium'] || '—' }}</td>
                                        <td>{{ props.item['prolong_order_status'] || '—' }}</td>
                                        <td @click.stop="">
                                            <v-select
                                                v-model="props.item['prolong_comment']"
                                                :items="commentsList"
                                                label="Введите комментарий"
                                                @change="commentChanged(props.item)"
                                                item-value="slug"
                                                item-text="text"
                                            ></v-select>
                                        </td>

                                        <td class="text-xs-right px-0" @click.stop="">
                                            <v-menu>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>more_vert</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile
                                                        :href="'/order/' + props.item['prolong_order_uuid']"
                                                        target="_blank"
                                                        v-if="props.item['prolong_order_uuid']"
                                                    >
                                                        <v-list-tile-title>Просмотр</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/prolongation/' + props.item['prolong_id'] + '/order/' + props.item['prev_order_uuid']"
                                                        target="_blank"
                                                        v-else
                                                    >
                                                        <v-list-tile-title>Продлить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="del(props.item)"
                                                    >
                                                        <v-list-tile-title>Удалить из пролонгации</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                        <v-menu
                                            v-model="props.item[25]"
                                            :position-x="menuX"
                                            :position-y="menuY"
                                        >
                                            <v-list>
                                                <v-list-tile
                                                    :href="'/order/' + props.item['prolong_order_uuid']"
                                                    target="_blank"
                                                    v-if="props.item['prolong_order_uuid']"
                                                >
                                                    <v-list-tile-title>Просмотр</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    :href="'/prolongation/' + props.item['prolong_id'] + '/order/' + props.item['prev_order_uuid']"
                                                    target="_blank"
                                                    v-else
                                                >
                                                    <v-list-tile-title>Продлить</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    @click="del(props.item)"
                                                >
                                                    <v-list-tile-title>Удалить из пролонгации</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </tr>
                                </template>
                                <template v-slot:items="props" v-else-if="isTermination">
                                    <tr :active="props.selected" @click="rowClickedTermination(props.item)">
                                        <td @click.stop="">
                                            <v-checkbox
                                                v-model="selected[props.item.id]"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <td>{{ props.item['curator_name'] || '—' }}<br>{{ props.item['curator_email'] }}</td>
                                        <td>{{ props.item['agent_name'] || '—' }}<br>{{ props.item['agent_email'] || '—' }}</td>
                                        <td>{{ props.item['operator_name'] || '—' }}<br>{{ props.item['operator_email'] || '—' }}
                                        </td>
                                        <td>
                                            {{ props.item['insurer_name'] }}
                                            <!--                                    <br>
                                                                                {{ props.item['prev_order_insurer_phone'] }}
                                                                                <br>
                                                                                {{ props.item['prev_order_insurer_email'] }}-->
                                        </td>
                                        <td>{{ props.item['policy_number'] || '—' }}</td>
                                        <td>{{ props.item['sign_at'] || '—' }}</td>
                                        <td class="ins-logo-container"> <!-- Лого компании -->
                                            <img class="ins-logo"
                                                 :src="props.item['company_logo']"
                                                 :alt="props.item['company_name']"/>
                                            {{ props.item['company_logo'] ? '' : props.item['company_name'] }}
                                        </td>
                                        <td>{{ props.item['status'] || '—' }}</td>
                                        <td>{{ props.item['policy_premium'] || '—' }}</td>
                                        <!--                                    {{ props.item['comment'] || '—' }}-->
                                        <img v-if="props.item['comment']"
                                             class="tip-icon pt-3" src="/svg/q.svg" alt=""
                                             data-tippy-animateFill="false"
                                             data-tippy-animation="scale"
                                             :data-tippy-content="props.item['comment']"
                                        />
                                        <p v-else> - </p>
                                        <td class="text-xs-right px-0" @click.stop="">
                                            <v-menu>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>more_vert</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile
                                                        :href="'/termination/' + props.item['id']"
                                                        target="_blank"
                                                        v-if="props.item['id']"
                                                    >
                                                        <v-list-tile-title>Просмотр</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/termination/' + props.item['id'] + '/copy'"
                                                        target="_blank"
                                                        v-if="props.item['id']"
                                                    >
                                                        <v-list-tile-title>Копия</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                        <v-menu
                                            v-model="props.item[25]"
                                            :position-x="menuX"
                                            :position-y="menuY"
                                        >
                                            <v-list>
                                                <v-list-tile
                                                    :href="'/termination/' + props.item['id']"
                                                    target="_blank"
                                                    v-if="props.item['id']"
                                                >
                                                    <v-list-tile-title>Просмотр</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile
                                                    :href="'/termination/' + props.item['prolong_id'] + '/copy'"
                                                    target="_blank"
                                                    v-if="props.item['id']"
                                                >
                                                    <v-list-tile-title>Копия</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                    </tr>
                                </template>
                                <template v-slot:items="props" v-else>
                                    <tr :active="props.selected" @click="rowClicked(props.item)" class="table-row">
                                        <td @click.stop="">
                                            <v-checkbox
                                                v-model="selected[props.item.order_uuid]"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <template v-if="showCurators">
                                            <td>{{ props.item['curator_name'] || '—' }}<br>{{ props.item['curator_email'] }}
                                            </td>
                                        </template>
                                        <template v-if="showAgents">
                                            <td>{{ props.item['agent_name'] || '—' }}<br>{{ props.item['agent_email'] || '—' }}
                                            </td>
                                        </template>
                                        <template v-if="showOperators && shownToggleableColumns['operator_name']">
                                            <td>{{
                                                    props.item['operator_name'] || '—'
                                                }}<br>{{ props.item['operator_email'] || '—' }}
                                            </td>
                                        </template>
                                        <td>
                                            <div>{{ getNameParts(props.item['insurer_name'])[0] }} {{ getNameParts(props.item['insurer_name'])[1] }}</div>
                                            <div>{{ getNameParts(props.item['insurer_name'])[2] }}</div>
                                        </td>
                                        <td>{{ props.item['order_product'] === 'Транзит' ? 'ОСАГО не РФ' : props.item['order_product'] || '—' }}</td>
                                        <template v-if="showSegment && shownToggleableColumns['widget_id']">
                                            <td>{{ props.item['widget_id'] || '—' }}</td>
                                        </template>
                                        <td>{{ props.item['sign_date_formatted'].slice(0, 10) }}<br>в
                                            {{ props.item['sign_date_formatted'].slice(11, 16) }}
                                        </td>
                                        <td>{{ props.item['begin_date_formatted'] || '—' }}</td>
                                        <td v-if="shownToggleableColumns['end_date_formatted']">{{
                                                props.item['end_date_formatted'] || '—'
                                            }}
                                        </td>
                                        <td class="ins-logo-container"> <!-- Лого компании -->
                                            <img v-if="props.item['comp_logo'] && props.item['order_status'] === 1000 "
                                                 class="ins-logo"
                                                 :src="props.item['comp_logo']"/>
                                            {{ props.item['comp_logo'] ? '' : props.item['comp_name'] }}
                                        </td>
                                        <td class="table-block">
                                            <div
                                                class="status-text"
                                                :class="{
                                                    'status-success': props.item['order_status_text_name'] === 'Оформлен',
                                                    'status-confirmed': props.item['order_status_text_name'] === 'Подтверждён',
                                                    'status-draft': props.item['order_status_text_name'] === 'Черновик',
                                                }"
                                            >
                                                {{ props.item['order_status_text_name'] || '—' }}
                                            </div>
                                        </td>
                                        <template v-if="showCommissions">
                                            <td class="text-md-center no-wrap">
                                                {{
                                                    props.item['commission_format'] && props.item['order_status'] === 1000 ? props.item['commission_format'] : '—'
                                                }}
                                            </td>
                                        </template>
                                        <td class="text-md-center no-wrap">
                                            {{
                                                props.item['premium_format'] && props.item['order_status'] === 1000 ? props.item['premium_format'] : '—'
                                            }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['kbm']">
                                            {{ props.item['kbm'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['address']">
                                            {{ props.item['address'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['pull']">
                                            {{ props.item['pull'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap"
                                            v-if="shownToggleableColumns['transport_license_plate']">
                                            {{ props.item['transport_license_plate'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['transport_mark']">
                                            {{ props.item['transport_mark'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['transport_model']">
                                            {{ props.item['transport_model'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['transport_vin']">
                                            {{ props.item['transport_vin'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap"
                                            v-if="shownToggleableColumns['transport_year_issue']">
                                            {{ props.item['transport_year_issue'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['transport_power']">
                                            {{ props.item['transport_power'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['cross_premium']">
                                            {{ props.item['cross_premium'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['prev_policy_status']">
                                            {{ props.item['prev_policy_status'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['prev_policy_company']">
                                            {{ props.item['prev_policy_company'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap"
                                            v-if="shownToggleableColumns['transport_power_avtocod']">
                                            {{ props.item['transport_power_avtocod'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['rsa_policy_number']">
                                            {{ props.item['rsa_policy_number'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['region']">
                                            {{ props.item['region'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['mortgage_bank']">
                                            {{ props.item['mortgage_bank'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['mortgage_risk']">
                                            {{ props.item['mortgage_risk'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['cross']">
                                            {{ props.item['cross'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['cross_commission']">
                                            {{ props.item['cross_commission'] || '—' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['is_prolongation']">
                                            {{ props.item['is_prolongation'] ? 'Да' : 'Нет' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['usage_purpose']">
                                            {{ props.item['usage_purpose'] || '-' }}
                                        </td>
                                        <td class="text-md-center no-wrap" v-if="shownToggleableColumns['base_tariff']">
                                            {{ props.item['base_tariff'] || '-' }}
                                        </td>
                                        <td class="text-md-center no-wrap"
                                            v-if="shownToggleableColumns['applied_segmentation']">
                                            {{ props.item['applied_segmentation'] || '—' }}
                                        </td>
                                        <td class="text-xs-right px-0 table-actions" @click.stop="">
                                            <v-menu>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>more_vert</v-icon>
                                                    </v-btn>
                                                </template>

                                        <!-- Действия для ОСАГО и пролонгации -->
                                        <v-list v-if="props.item['order_product'] === 'ОСАГО' || props.item['order_product'] === 'Пролонгация ОСАГО'">
                                            <v-list-tile
                                                @click="download(props.item)"
                                                v-if="props.item['order_status'] === 1000"
                                            >
                                                <v-list-tile-title>Скачать Полис</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                v-if="props.item['order_status'] === 1000"
                                                href="/docs/policy-list/protocol_blue.pdf"
                                                target="_blank"
                                            >
                                                <v-list-tile-title>Скачать Извещение о ДТП</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/osago/new/' + props.item['order_uuid'] + '/termination'"
                                                target="_blank"
                                                v-if="props.item['maybe_terminated']"
                                            >
                                                <v-list-tile-title>Расторгнуть полис</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'https://pyrus.com/form/1544502'"
                                                target="_blank"
                                                v-if="props.item['order_status']===1000"
                                            >
                                                <v-list-tile-title>Заявить убыток</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item['order_uuid'] + '/prolong'"
                                                target="_blank"
                                                v-if="props.item['order_status']===1000 && !props.item['is_egarant'] && isWithinDays(props.item['end_date_formatted'])"
                                            >
                                                <v-list-tile-title>Продлить</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item['order_uuid'] + '/draft'"
                                                target="_blank"
                                            >
                                                <v-list-tile-title>Использовать как черновик</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                :href="'/order/' + props.item['order_uuid']"
                                                target="_blank"
                                                v-if="props.item['order_status'] === 1000"
                                            >
                                                <v-list-tile-title>Просмотр</v-list-tile-title>
                                            </v-list-tile>

                                            <v-list-tile
                                                :href="props.item['maybe_changed'] === true ? '/osago/new/' + props.item['order_uuid'] + '/change' : null"
                                                target="_blank"
                                                :disabled="props.item['maybe_changed'] === false"
                                                v-if="props.item['maybe_changed'] !== null && role === 'admin'"
                                            >
                                                <v-list-tile-title>
                                                    Внести изменения
                                                    <span v-if="props.item['maybe_changed'] === false"
                                                          class="grey--text"> (лимит исчерпан)</span>
                                                </v-list-tile-title>
                                            </v-list-tile>

                                            <!-- Доп. соглашения (показывать только когда есть оформленные изменения) -->
                                            <template v-if="props.item['supplementary_agreements'] && props.item['supplementary_agreements'].length > 0">
                                                <v-list-tile
                                                    v-for="agr in props.item['supplementary_agreements']"
                                                    :key="agr.n"
                                                    :href="agr.url"
                                                    target="_blank"
                                                >
                                                    <v-list-tile-title>
                                                        Доп. соглашение {{ agr.n }}
                                                    </v-list-tile-title>
                                                </v-list-tile>
                                            </template>

                                            <v-list-tile
                                                :href="'/order/' + props.item['order_uuid'] + '/edit'"
                                                target="_blank"
                                                v-if="props.item['order_status']!==1000 && !props.item['is_egarant']"
                                            >
                                                <v-list-tile-title>Редактировать</v-list-tile-title>
                                            </v-list-tile>
                                            <v-list-tile
                                                @click="del(props.item)"
                                                v-if="props.item['order_status']!==1000"
                                            >
                                                <v-list-tile-title>Удалить</v-list-tile-title>
                                            </v-list-tile>
                                        </v-list>

                                                <!-- Действия для Ипотеки -->
                                                <v-list v-else-if="props.item['order_product'] === 'Страхование ипотеки'">
                                                    <v-list-tile
                                                        :href="'/order/' + props.item['order_uuid']"
                                                        target="_blank"
                                                        v-if="props.item['order_status'] === 1000"
                                                    >
                                                        <v-list-tile-title>Просмотр</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/order/' + props.item['order_uuid'] + '/edit'"
                                                        target="_blank"
                                                        v-if="props.item['order_status']!==1000 && !props.item['is_egarant']"
                                                    >
                                                        <v-list-tile-title>Редактировать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/order/' + props.item['order_uuid'] + '/prolong'"
                                                        target="_blank"
                                                        v-if="props.item['order_status']===1000 && !props.item['is_egarant'] && isWithinDays(props.item['end_date_formatted'])"
                                                    >
                                                        <v-list-tile-title>Продлить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/order/' + props.item['order_uuid'] + '/draft'"
                                                        target="_blank"
                                                    >
                                                        <v-list-tile-title>Использовать как черновик</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="download(props.item)"
                                                        v-if="props.item['order_status']===1000"
                                                    >
                                                        <v-list-tile-title>Скачать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/osago/new/' + props.item['order_uuid'] + '/termination'"
                                                        target="_blank"
                                                        v-if="props.item['maybe_terminated']"
                                                    >
                                                        <v-list-tile-title>Расторжение</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="del(props.item)"
                                                        v-if="props.item['order_status']!==1000"
                                                    >
                                                        <v-list-tile-title>Удалить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'https://pyrus.com/form/1544502'"
                                                        target="_blank"
                                                        v-if="props.item['order_status']===1000"
                                                    >
                                                        <v-list-tile-title>Заявить убыток</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>

                                                <!-- Действия для Антиклеща -->
                                                <v-list v-else-if="props.item['order_product'] === 'Анти Клещ'">
                                                    <v-list-tile
                                                        :href="'/antimite/' + props.item['order_uuid']"
                                                        target="_blank"
                                                        v-if="props.item['order_status'] === 1000"
                                                    >
                                                        <v-list-tile-title>Просмотр</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/antimite/' + props.item['order_uuid']"
                                                        target="_blank"
                                                        v-else-if="props.item['order_status']!==1000 && !props.item['is_egarant']"
                                                    >
                                                        <v-list-tile-title>Редактировать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        href=""
                                                        target="_blank"
                                                        v-if="props.item['order_status']===1000 && !props.item['is_egarant']"
                                                    >
                                                        <v-list-tile-title>Продлить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/antimite/' + props.item['order_uuid'] + '/copy'"
                                                        target="_blank"
                                                    >
                                                        <v-list-tile-title>Использовать как черновик</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="download(props.item)"
                                                        v-if="props.item['order_status']===1000"
                                                    >
                                                        <v-list-tile-title>Скачать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="del(props.item)"
                                                        v-if="props.item['order_status']!==1000"
                                                    >
                                                        <v-list-tile-title>Удалить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'https://pyrus.com/form/1544502'"
                                                        target="_blank"
                                                        v-if="props.item['order_status']===1000"
                                                    >
                                                        <v-list-tile-title>Заявить убыток</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>

                                                <!-- Действия для ОСАГО не РФ -->
                                                <v-list v-else-if="props.item['order_product'] === 'Транзит'">
                                                    <v-list-tile
                                                        :href="'/transit-osago/' + props.item['order_uuid']"
                                                        target="_blank"
                                                        v-if="props.item['order_status'] === 1000"
                                                    >
                                                        <v-list-tile-title>Просмотр</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/transit-osago/' + props.item['order_uuid']"
                                                        target="_blank"
                                                        v-else-if="props.item['order_status']!==1000 && !props.item['is_egarant']"
                                                    >
                                                        <v-list-tile-title>Редактировать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        href=""
                                                        target="_blank"
                                                        v-if="props.item['order_status']===1000 && !props.item['is_egarant']"
                                                    >
                                                        <v-list-tile-title>Продлить</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        :href="'/transit-osago/' + props.item['order_uuid'] + '/copy'"
                                                        target="_blank"
                                                    >
                                                        <v-list-tile-title>Использовать как черновик</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="download(props.item)"
                                                        v-if="props.item['order_status']===1000"
                                                    >
                                                        <v-list-tile-title>Скачать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile
                                                        @click="del(props.item)"
                                                        v-if="props.item['order_status']!==1000"
                                                    >
                                                        <v-list-tile-title>Удалить</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:pageText="props">
                                    {{ props.pageStart }} - {{ props.pageStop }} из {{ props.itemsLength }}
                                </template>
                            </v-data-table>

                            <v-layout py-0 row wrap>
                                <v-flex xs6 v-show="selected.length" style="margin-top: -70px">
                                    Выделено полисов: {{ selected.length }}<br>
                                    <a @click="groupDel(selected)" class="link">Удалить выделенные</a>
                                </v-flex>
                            </v-layout>
                        </div>
                    </div>
                </v-container>
            </v-form>
        </v-content>
    </v-app>

</template>

<script>
import _ from 'lodash'
import PolicyTypeDialogButton from "../elements/PolicyTypeDialogButton";

export default {
    props: [
        'role',
        'showcommissions',
        'showsegment',
        'list',
        'total',
        'errors',
        'companies',
        'egarant-companies',
        'egarant-user',
        'policy-types',
        'regions',
        'comments',
        'prolong-active-count',
        'user',
    ],

    components: {
        'b2b-policy-type-dialog': PolicyTypeDialogButton
    },
    updated: function () {
        window.tippy.default('.tip-icon');
        },
    data: () => ({
        filters: {
            tab: 0,
            search: '',
            curatorSearch: '',
            agentSearch: '',
            operatorSearch: '',
            regionSearch: '',
            companySearch: '',
            company: '',
            date_from: null,
            date_to: null,
            beg_date_from: null,
            beg_date_to: null,
            end_date_from: null,
            end_date_to: null,
            curator: [],
            agent: [],
            operator: [],
            is_egarant: false,
            segment: null,
            policy_type: null,
            region: null,
            is_pull: null,
            is_cross_sale: null,
            usage_purpose: null,
            base_tariff: null,
        },
        pagination: {
            descending: true,
            sortBy: '3',
            page: 1,
            rowsPerPage: 10,
            totalItems: 0
        },
        companiesList: [],
        egarantCompaniesList: [],
        tabsList: ['Все', 'Черновики', 'Подтверждённые', 'Оформленные', 'Пролонгация', 'Расторжение'],
        curatorsList: [],
        agentsList: [],
        operatorsList: [],
        segmentsList: [{id: null, name: 'Любой'}, {id: 'B2B', name: 'B2B'}, {id: 'B2C', name: 'B2C'}],
        typesList: [
            {id: null, name: 'Любой'},
            {id: 'OSAGO_NEW', name: 'ОСАГО'},
            {id: 'OSAGO_PROLONG', name: 'Пролонгация ОСАГО'},
            {id: 'MORTGAGE', name: 'Страхование ипотеки'},
            {id: 'ANTI_MITE', name: 'Антиклещ'},
            {id: 'TRANSIT', name: 'ОСАГО не РФ'},
        ],
        IsPullTypesList: [
            {id: null, name: 'Любой'},
            {id: 'is_pull', name: 'Пул'},
            {id: 'isnt_pull', name: 'Не Пул'}
        ],
        crossSaleList: [
            {id: null, name: 'Любой'},
            {id: 'is_cross_sale', name: 'Да'},
            {id: 'isnt_cross_sale', name: 'Нет'},
        ],
        usagePurposeList: [
            {id: null, name: 'Любой'},
            {id: 'taxi', name: 'Такси'},
            {id: 'personal', name: 'Личная'},
            {id: 'educational', name: 'Учебная езда'},
        ],
        regionsList: [],
        prolongCount: 0,

        headers: [],
        headersProlong: [],
        isProlong: false,
        isProlongShow: false,
        headersTermination: [],
        isTermination: false,
        isTerminationShow: false,
        rows: [],
        totalRows: 0,
        selected: [],
        tab: 0,
        toggleableColumns: [],
        shownToggleableColumns: {},

        downloadFields: {},
        prolongDownloadFields: {},
        terminationDownloadFields: {},

        showCurators: false,
        showAgents: false,
        showOperators: false,
        showCommissions: false,
        showSegment: false,

        loading: false,
        canDownload: false,
        init: false,

        isLoadingOperatorsFilter: false,
        isLoadingAgentsFilter: false,
        isLoadingCuratorsFilter: false,
        monthCommission: 0,
        commissionByMonth: '',

        policyTypesArray: [],
        commentsList: [],
        toDisplay: false,
        menuX: 0,
        menuY: 0,

        activeHeaders: [],

        // variables for prolongation date picker
        currentDate: null, // current date for prolongation next_call_date picker
        selectedProlongId: null, // prolongation id for prolongation next_call_date picker

        panel: [],
        isRewardLoading: false,
    }),

    watch: {
        'pagination.descending': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.sortBy': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.page': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.rowsPerPage': {
            handler() {
                this.paginationHandle();
            }
        },
        'pagination.totalItems': {
            handler() {
                this.paginationHandle();
            }
        },
        'filters.tab': {
            handler() {
                this.paginationHandle();
            }
        },
        'filters.usage_purpose': {
            handler() {
                this.paginationHandle();
            }
        },
        filters: {
            handler() {
                if (!this.init) {
                    return;
                }
                // TODO: для обработки доступности кнопки
                //console.log('I\'ll be watching you', this.filters);
            },
            deep: true
        }
    },

    created: function () {
        if (this.errors) {
            PNotify.error('Возникли ошибки при поиске');
        }
        if (this.role === 'admin') {
            this.showCurators = true;
            this.showAgents = true;
            this.showOperators = true;
            this.showCommissions = true;
            this.showSegment = true;
        } else if (this.role === 'curator') {
            this.showAgents = true;
            this.showOperators = true;
            this.showCommissions = true;
            this.showSegment = this.showsegment;
        } else if (this.role === 'agent') {
            this.showOperators = true;
            this.showCommissions = true;
            this.showSegment = this.showsegment;
        } else if (this.role === 'operator') {
            this.showCommissions = this.showcommissions;
            this.showSegment = this.showsegment;
        }

        if (this.role !== 'admin') {
            this.filters.is_egarant = this.egarantUser;
        }

        this.rows = JSON.parse(window.atob(this.list));
        for (let i = 0; i < this.rows.length; i++) {
            Vue.set(this.rows[i], this.rows[i].length, false);
        }
        this.totalRows = this.total;

        this.prolongCount = this.prolongActiveCount

        this.headers = [
            {text: 'Куратор', value: 'curator_name', sortable: false},
            {text: 'Пользователь', value: 'agent_name', sortable: false},
            {text: 'Сотрудник', value: 'operator_name', sortable: false, toggleable: true, visibleDefault: true},
            {text: 'Страхователь', value: 'insurer_name', sortable: false, width: 140},
            {text: 'Тип полиса', value: 'order_product', sortable: false},
            {text: 'Канал продаж', value: 'widget_id', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Оформлен', value: 'sign_date_formatted'},
            {text: 'Дата начала', value: 'begin_date_formatted'},
            {text: 'Дата окончания', value: 'end_date_formatted', toggleable: true, visibleDefault: false},
            {text: 'Компания', value: 'comp_name', sortable: false},
            {text: 'Статус', value: 'order_status_text_name', sortable: false},
            {text: 'Вознаграждение', value: 'commission_format', sortable: false},
            {text: 'Страховая премия', value: 'premium_format', sortable: false},
            {text: 'КБМ', value: 'kbm', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Адрес регистрации', value: 'address', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Пул', value: 'pull', sortable: false, toggleable: true, visibleDefault: false},
            {
                text: 'Гос. Номер',
                value: 'transport_license_plate',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {text: 'Марка ТС', value: 'transport_mark', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Модель', value: 'transport_model', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'VIN / № Кузова', value: 'transport_vin', sortable: false, toggleable: true, visibleDefault: false},
            {
                text: 'Год выпуска',
                value: 'transport_year_issue',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {text: 'Мощность ТС', value: 'transport_power', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Стоимость кросс', value: 'cross_premium', sortable: false, toggleable: true, visibleDefault: false},
            {
                text: 'Зеленый коридор',
                value: 'prev_policy_status',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Предыдущая СК',
                value: 'prev_policy_company',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Мощность ТС Автокод',
                value: 'transport_power_avtocod',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Номер полиса в РСА',
                value: 'rsa_policy_number',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {text: 'Регион', value: 'region', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Банк', value: 'mortgage_bank', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Страховые риски', value: 'mortgage_risk', sortable: false, toggleable: true, visibleDefault: false},
            {text: 'Кросс', value: 'cross', sortable: false, toggleable: true, visibleDefault: false},
            {
                text: 'Вознаграждение кросс',
                value: 'cross_commission',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Пролонгация',
                value: 'is_prolongation',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Цель использования',
                value: 'usage_purpose',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
            {
                text: 'Базовый тариф',
                value: 'base_tariff',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            },
        ];

        if (this.role === 'admin') {
            this.headers.push({
                text: 'Примененная сегментация',
                value: 'applied_segmentation',
                sortable: false,
                toggleable: true,
                visibleDefault: false
            })
        }

        this.headers.push({text: '', value: '', sortable: false, class: 'px-0'});

        this.headersProlong = [
            {text: 'Куратор', value: '119', sortable: false, width: 180, paddings: 10},
            {text: 'Пользователь', value: '117', sortable: false, width: 180, paddings: 10},
            {text: 'Сотрудник', value: '123', sortable: false, width: 180, paddings: 10},
            {text: 'Страхователь', value: '102', sortable: false, width: 250, paddings: 10},
            {text: 'Тип полиса', value: '131', sortable: false, width: 108, paddings: 10},
            {text: 'Дата окончания', value: '105', sortable: false},
            {text: 'Дата звонка', value: '101', sortable: true, width: 180},
            {text: 'Предыдущая СК', value: '142', sortable: false},
            {text: 'Страховая премия', value: '113', sortable: false},
            {text: 'Статус', value: '109', sortable: false},
            {text: 'Комментарий', value: '111', sortable: false, width: 200, maxWidth: 250},
        ]

        this.headersTermination = [
            {text: 'Куратор', value: 'curator_name', sortable: false},
            {text: 'Пользователь', value: 'agent_name', sortable: false},
            {text: 'Сотрудник', value: 'operator_name', sortable: false, visibleDefault: true},
            {text: 'Страхователь', value: 'insurer_name', sortable: false, width: 200},
            {text: 'Номер полиса', value: 'policy_number', sortable: false},
            {text: 'Дата оформления', value: 'sign_at', sortable: false},
            {text: 'Компания', value: 'company_name', sortable: false},
            {text: 'Статус', value: 'status', sortable: false},
            {text: 'Страховая премия', value: 'policy_premium', sortable: false},
            {text: 'Комментарий', value: 'comment', sortable: false},
        ]

        let toggleable = [];
        let shownToggleable = {};
        this.headers.forEach(header => {
            if (header.toggleable) {
                const id = header.value;
                toggleable.push({'name': header.text, 'id': id});
                shownToggleable[id] = header.visibleDefault;
            }
        });
        this.headersProlong.forEach(header => {
            if (header.toggleable) {
                const id = parseInt(header.value);
                toggleable.push({'name': header.text, 'id': id});
                shownToggleable[id] = header.visibleDefault;
            }
        });
        this.headersTermination.forEach(header => {
            if (header.toggleable) {
                const id = parseInt(header.value);
                toggleable.push({'name': header.text, 'id': id});
                shownToggleable[id] = header.visibleDefault;
            }
        });
        this.toggleableColumns = toggleable;
        this.shownToggleableColumns = shownToggleable;

        this.downloadFields = {
            '#': 'order_uuid',
            'Куратор': 'curator_name',
            'Email куратора': 'curator_email',
            'Пользователь': 'agent_name',
            'Email пользователя': 'agent_email',
            'Сотрудник': 'operator_name',
            'Email сотрудника': 'operator_email',
            'Страхователь': 'insurer_name',
            'Адрес Регистрации': 'address',
            'Гос. Номер': 'transport_license_plate',
            'Марка ТС': 'transport_mark',
            'Модель': 'transport_model',
            'VIN / № Кузова': 'transport_vin',
            'Год выпуска': 'transport_year_issue',
            'Мощность ТС': 'transport_power',
            'Мощность ТС Автокод': 'transport_power_avtocod',
            'Телефон страхователя': 'insurer_phone',
            'Email страхователя': 'insurer_email',
            'Канал продаж': 'widget_id',
            'Дата оформления': 'sign_date_formatted',
            'Дата начала': 'begin_date_formatted',
            'Дата окончания': 'end_date_formatted',
            'Компания': 'comp_name',
            'Статус': 'order_status_text_name',
            'Вознаграждение': 'commission_format',
            'Страховая премия': 'premium_format',
            'Пулл': 'pull',
            'Стоимость кросс': 'cross_premium',
            'Предыдущий полис активен': 'prev_policy_status',
            'СК предыдущего полиса': 'prev_policy_company',
            'КБМ': 'kbm',
            'Тип полиса': 'order_product',
            'Номер полиса в РСА': 'rsa_policy_number',
            'Примененная сегментация': 'applied_segmentation',
            'Регион': 'region',
            'Банк': 'mortgage_bank',
            'Страховые риски': 'mortgage_risk',
            'Кросс': 'cross',
            'Вознаграждение кросс': 'cross_commission',
            'Категория ТС из анкеты ОСАГО': 'transport_category',
            'марка и модель авто из ГИБДД': 'gibdd_model',
            'мощность из ГИБДД': 'gibdd_power',
            'Категория ТС из ГИБДД': 'gibdd_category',
            'Разность мощностей': 'power_diff',
            'Категории совпадают': 'category_same',
            'Цель использования': 'usage_purpose',
            'Пролонгация': 'is_prolongation',
            'Базовый тариф': 'base_tariff',
        };

        this.prolongDownloadFields = {
            'Куратор': '8',
            'Пользователь': '5',
            'Сотрудник': '3',
            'Страхователь': '10',
            'Тип полиса': '23',
            'Дата окончания': '13',
            'Дата звонка': '14',
            'Предыдущая СК': '15',
            'Страховая премия': '17',
            'Статус': '18',
            'Комментарий': '19',
        }

        this.terminationDownloadFields = {
            'Куратор': 'curator_name',
            'Пользователь': 'agent_name',
            'Сотрудник': 'operator_name',
            'Страхователь': 'insurer_name',
            'Номер полиса': 'policy_number',
            'Дата оформления': 'created_at',
            'Компания': 'company_name',
            'Статус': 'status',
            'Страховая премия': 'policy_premium',
            'Комментарий': 'comment',
        }

        if (!this.showCurators) {
            _.remove(this.headers, {text: 'Куратор'});
            delete this.downloadFields['Куратор'];
            delete this.downloadFields['email куратора'];
        }
        if (!this.showAgents) {
            _.remove(this.headers, {text: 'Пользователь'});
            delete this.downloadFields['Пользователь'];
            delete this.downloadFields['email пользователя'];
        }
        if (!this.showOperators) {
            _.remove(this.headers, {text: 'Сотрудник'});
            delete this.downloadFields['Сотрудник'];
            delete this.downloadFields['email сотрудник'];
        }
        if (!this.showCommissions) {
            _.remove(this.headers, {text: 'Вознаграждение'});
            delete this.downloadFields['Вознаграждение'];
        }
        if (!this.showSegment) {
            _.remove(this.headers, {text: 'Канал продаж'});
            delete this.downloadFields['Канал продаж'];
        }

        this.companiesList = Object.values(JSON.parse(window.atob(this.companies)));
        this.companiesList.sort(this.sortByName).unshift({alias: 'all', name: 'Все'});
        this.egarantCompaniesList = JSON.parse(window.atob(this.egarantCompanies));
        this.egarantCompaniesList.sort(this.sortByName).unshift({alias: 'all', name: 'Все'});

        this.policyTypesArray = JSON.parse(window.atob(this.policyTypes));

        if (this.user && !this.user.is_transit_open) {
            this.policyTypesArray = this.policyTypesArray.filter(item => item.name !== 'ОСАГО не РФ');
        }

        this.regionsList = Object.values(this.regions)
        this.regionsList.unshift({name: 'Любой', name_with_type: 'Любой'})
        this.commentsList = Object.values(this.comments)

        this.init = true;
        this.activeHeaders = this.headers

        let newPolisButtons = [...document.getElementsByClassName('newPolis')]
        newPolisButtons.forEach((item) => {
            item.addEventListener('click', (e) => {
                e.preventDefault()
                this.toDisplay = true
            })
        })
    },

    methods: {
        formatNumber(value) {
            if (!value) return '0';
            return new Intl.NumberFormat('ru-RU').format(Number(value));
        },

        showFilters() {
            this.panel = this.panel.length ? [] : ['0'];
        },

        getNameParts(fullName) {
            if (!fullName) return ['', '', '']

            const parts = fullName.split(' ')

            return [
                parts[0] || '',
                parts[1] || '',
                parts[2] || ''
            ]
        },

        changeDialog(value) {
            this.toDisplay = value
        },

        prolongSearch() {
            PNotify.info('На данный момент в разделе "Пролонгация" поиск не работает');
        },

        newSearch() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: this.pagination.rowsPerPage,
                f: JSON.stringify(this.filters),
                prolong: this.isProlong
            };
            this.loading = true;
            axios.post('/policy-list', data)
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        this.rows = JSON.parse(window.atob(response.data.list));

                        for (let i = 0; i < this.rows.length; i++) {
                            Vue.set(this.rows[i], this.rows[i].length, false);
                        }
                        this.totalRows = response.data.total;
                        this.isProlongShow = this.isProlong
                    } else {
                        PNotify.error('Возникли ошибки при поиске');
                        console.log(response);
                    }
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Возникли ошибки при поиске');
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        rowClicked(item) {
            // window.open может быть подавлен политикой Firefox по запрету всплывающих окон,
            // поэтому конструируем новый элемент и кликаем по нему, а потом удаляем
            let link = document.createElement('a');
            link.id = 'my_link';
            link.style.cssText = 'display: none';
            if (item['order_product'] === 'Анти Клещ') {
                link.href = '/antimite/' + item['order_uuid'];
            } else if (item['order_product'] === 'Транзит') {
                link.href = '/transit-osago/' + item['order_uuid'];
            } else {
                link.href = item['order_status'] === 1000 || item['is_egarant'] ? '/order/' + item['order_uuid'] : '/order/' + item['order_uuid'] + '/edit';
            }
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            link = undefined;
        },

        rowClickedTermination(item) {
            window.open('/termination/' + item.id, '_blank');
        },

        showMenu(e, item) {
            e.preventDefault();
            Vue.set(item, 25, false);
            this.menuX = e.clientX;
            this.menuY = e.clientY;
            this.$nextTick(() => {
                Vue.set(item, 25, true);
            })
        },

        toggleAll() {
            if (this.selected.length) {
                this.selected = [];
            } else {
                this.selected = this.$refs.policyListTable.filteredItems.slice();
            }
        },

        changeSort(column) {
            if (this.pagination.sortBy === column) {
                this.pagination.descending = !this.pagination.descending;
            } else {
                this.pagination.sortBy = column;
                this.pagination.descending = false;
            }
        },

        changeTab(index) {
            this.filters.tab = index;
            this.pagination.page = 1;
            if (index !== undefined) {
                this.isProlong = index === 4
                this.isTermination = index === 5
                if (this.isProlong) {
                    this.activeHeaders = this.headersProlong
                    this.pagination.sortBy = '101'
                } else if (this.isTermination) {
                    this.activeHeaders = this.headersTermination
                    this.pagination.sortBy = 'created_at'
                } else {
                    this.activeHeaders = this.headers
                    this.pagination.sortBy = '3'
                }
            }
        },

        cleanFilters() {
            this.filters.search = '';
            this.filters.curatorSearch = '';
            this.filters.agentSearch = '';
            this.filters.operatorSearch = '';
            this.filters.regionSearch = '';
            this.filters.companySearch = '';
            this.filters.company = '';
            this.filters.date_from = null;
            this.filters.date_to = null;
            this.filters.beg_date_from = null;
            this.filters.beg_date_to = null;
            this.filters.end_date_from = null;
            this.filters.end_date_to = null;
            this.filters.agent = [];
            this.filters.curator = [];
            this.filters.operator = [];
            if (this.role === 'admin') {
                this.filters.is_egarant = false;
            }
            this.filters.segment = null;
            this.filters.policy_type = null;
            this.filters.region = null;
            this.filters.is_pull = null;
            this.filters.is_cross_sale = null;
            this.filters.usage_purpose = null;
            this.newSearch();
        },

        async downloadItems() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: -1,
                f: JSON.stringify(this.filters),
                prolong: this.isProlong
            };
            this.loading = true;
            let result = [];
            await axios.post('/policy-list', data)
                .then(response => {
                    if (response.data && response.data.status === 'success') {
                        result = JSON.parse(window.atob(response.data.list));
                    } else {
                        PNotify.error('Возникли ошибки при формировании файла');
                        console.log(response);
                    }
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Возникли ошибки при формировании файла');
                    this.loading = false;
                });

            return result;
        },

        download(item) {
            if (item['order_product'] === 'Анти Клещ') {
                window.location.href = '/antimite/' + item['order_uuid'] + '/download';
            } else if (item['order_product'] === 'Транзит') {
                window.location.href = '/transit-osago/' + item['order_uuid'] + '/download';
            } else {
                window.location.href = '/order/' + item['order_uuid'] + '/download';
            }
        },

        del(item) {
            let that = this;
            let text = this.isProlong ? 'Удалить запись?' : 'Удалить полис?';
            let url = '';
            if (item['order_product'] === 'Анти Клещ') {
                url = '/antimite' + item['order_uuid'] + '/delete';
            } else {
                url = (this.isProlong ? '/prolongation/' : '/order/') + item['order_uuid'] + '/delete';
            }
            PNotify.error({
                text: text,
                hide: false,
                stack: {
                    'dir1': 'down',
                    'modal': true,
                    'firstpos1': 25
                },
                modules: {
                    Confirm: {
                        confirm: true,
                        buttons: [
                            {
                                text: 'Удалить',
                                primary: false,
                                click: function () {
                                    axios.get(url)
                                        .then(response => {
                                            if (item['order_product'] === 'Анти Клещ') {
                                                Vue.delete(that.rows, that.rows.findIndex((v) => v[0] === item['order_id']));
                                            } else {
                                                Vue.delete(that.rows, that.rows.findIndex((v) => v[0] === item['order_uuid']));
                                            }
                                            this.makeActive(item)
                                            PNotify.removeAll();
                                        }).catch(error => {
                                        console.log(error.response);
                                        PNotify.removeAll();
                                        if (error.response && error.response.data.message) {
                                            PNotify.alert(error.response.data.message);
                                        }
                                    });
                                },
                            },
                            {
                                text: 'Отмена',
                                primary: false,
                                click: () => {
                                    PNotify.removeAll();
                                },
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    },
                    History: {
                        history: false
                    }
                }
            });
        },
        getCurrentDate(id) {
            const date = new Date();
            this.currentDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000)).toISOString().slice(0,10);
            this.selectedProlongId = id
        },
        dataStartChanged(item) {
            if (this.loading) return
            this.loading = true

            const date = item['next_call_date']
            const hasInvalidDate = !date || !date.match(/^\d{4}-\d{2}-\d{2}$/)
            const currentDateTimestamp = new Date(this.currentDate).getTime()
            const dateTimestamp = new Date(date).getTime()

            if (!hasInvalidDate && currentDateTimestamp <= dateTimestamp) {
                axios.put(`/prolongation/${item['prolong_id']}/update-call-date/${date}`)
                    .then(response => {
                        PNotify.success('Дата следующего звонка обновлена');
                        this.makeActive(item)
                    })
                    .catch(error => {
                        // PNotify.error(error.response.data.message);
                        PNotify.error('Ошибка обновления даты следующего звонка');
                    })
                    .finally(() => {
                        this.loading = false
                        this.selectedProlongId = null
                    });
            } else {
                this.loading = false
                this.selectedProlongId = null
                item['next_call_date'] = ''
            }
        },
        commentChanged(item) {
            if (this.loading) return
            this.loading = true
            axios.put(`/prolongation/${item['prolong_id']}/update-comment/${item['prolong_comment']}`)
                .then(response => {
                    PNotify.success(`Комментарий обновлён`);
                    this.makeActive(item)
                }).catch(error => {
                console.log(error.response);
                if (error.response && error.response.data.message) {
                    PNotify.error(error.response.data.message);
                }
            }).finally(() => {
                this.loading = false
            });
        },

        makeActive(item) {
            if (this.isProlong && !item['prolong_next_call_date']) {
                this.prolongCount--
                item['prolong_next_call_date'] = true
            }
        },

        groupDel(items) {
            let that = this;
            PNotify.error({
                text: 'Удалить полисы? (Всего: ' + items.length + ')',
                hide: false,
                stack: {
                    'dir1': 'down',
                    'modal': true,
                    'firstpos1': 25
                },
                modules: {
                    Confirm: {
                        confirm: true,
                        buttons: [
                            {
                                text: 'Удалить',
                                primary: false,
                                click: function () {
                                    axios.post('/list/delete', {orders: items.join(',')})
                                        .then(response => {
                                            response.data.deleted.forEach(
                                                (uuid) => Vue.delete(
                                                    that.rows,
                                                    that.rows.findIndex((v) => v[0] === uuid)
                                                )
                                            );
                                            PNotify.removeAll();

                                            if (items.length !== response.data.deleted.length) {
                                                PNotify.alert(`Удалено ${response.data.deleted.length} из ${items.length}:
                                                        для остальных отсутствуют права на удаление либо не позволяет статус полиса.`);
                                            }
                                        }).catch(error => {
                                        console.log(error.response);
                                        PNotify.removeAll();
                                        if (error.response && error.response.data.message) {
                                            PNotify.alert(error.response.data.message);
                                        }
                                    });
                                },
                            },
                            {
                                text: 'Отмена',
                                primary: false,
                                click: () => {
                                    PNotify.removeAll();
                                },
                            }
                        ]
                    },
                    Buttons: {
                        closer: false,
                        sticker: false
                    },
                    History: {
                        history: false
                    }
                }
            });
        },

        isEgarantChanged() {
            this.filters.company = '';
        },

        sortByName(objA, objB) {
            return objA.name < objB.name ? -1 : 1;
        },

        paginationHandle() {
            if (!this.init) {
                return;
            }
            this.newSearch();
        },

        onCuratorFocus() {
            this.searchCuratorsFilter();
        },

        onAgentFocus() {
            this.searchAgentsFilter();
        },

        onOperatorFocus() {
            this.searchOperatorsFilter();
        },

        async searchOperatorsFilter() {
            // Данные загружаются или уже получены
            if (this.isLoadingOperatorsFilter || this.operatorsList.length > 0) {
                return;
            }
            this.isLoadingOperatorsFilter = true;
            axios.get('/policy-operators').then(response => {
                this.operatorsList = JSON.parse(window.atob(response.data.data));
                this.operatorsList.sort(this.sortByName);
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить список сотрудников');
            }).finally(() => {
                this.isLoadingOperatorsFilter = false;
            })
        },

        async searchAgentsFilter() {
            // Данные загружаются или уже получены
            if (this.isLoadingAgentsFilter || this.agentsList.length > 0) {
                return;
            }
            this.isLoadingAgentsFilter = true;
            axios.get('/policy-agents').then(response => {
                this.agentsList = JSON.parse(window.atob(response.data.data));
                this.agentsList.sort(this.sortByName);
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить список пользователей');
            }).finally(() => {
                this.isLoadingAgentsFilter = false;
            })
        },

        async searchCuratorsFilter() {
            // Данные загружаются или уже получены
            if (this.isLoadingCuratorsFilter || this.curatorsList.length > 0) {
                return;
            }
            this.isLoadingCuratorsFilter = true;
            axios.get('/policy-curators').then(response => {
                this.curatorsList = JSON.parse(window.atob(response.data.data));
                this.curatorsList.sort(this.sortByName);
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить список кураторов');
            }).finally(() => {
                this.isLoadingCuratorsFilter = false;
            })
        },

        toggleColumn(event, index) {
            this.shownToggleableColumns[index] = event;
        },

        balanceDateChanged(val) {
            this.isRewardLoading = true;

            axios.get('/accounting-balance?month=' + val).then(response => {
                if (response.data && response.data.status === 'ok') {
                    this.commissionByMonth = response.data.sum;
                } else {
                    console.log(response);
                    PNotify.alert('Не удалось получить баланс');
                }
            }).catch(error => {
                console.log(error);
                PNotify.alert('Не удалось получить баланс');
            }).finally(() => {
                this.isRewardLoading = false;
            });
        },

        async downloadExport() {
            if (this.loading) {
                return;
            }
            const data = {
                s: this.pagination.sortBy,
                desc: this.pagination.descending,
                p: this.pagination.page,
                i: -1,
                f: JSON.stringify(this.filters),
                prolong: this.isProlong
            };
            this.loading = true;
            await axios.post('/list/export', data, {
                responseType: 'blob'
            }).then(response => {
                console.log(response)
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'policy-export.xlsx'); // Название файла, который будет сохранен
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            })
                .catch(error => {
                    console.log(error);
                    PNotify.error('Возникли ошибки при формировании файла');
                    this.loading = false;
                });
            this.loading = false;
        },
        dateToString(date) {
            const [day, month, year] = date.split('.').map(Number);

            return new Date(year, month - 1, day);
        },

        addDaysToDate(date, days) {
            const newDate = new Date(date);

            newDate.setDate(newDate.getDate() + days);

            return newDate;
        },

        isWithinDays(date) {
            const originalDate = this.dateToString(date);

            const datePlusDays = this.addDaysToDate(originalDate, 60);

            return Date.now() <= datePlusDays;
        }
    }
}

function dateToTimestampSeconds(val) {
    // val must be in 'YYYY-MM-DD' format
    const a = val.split(/[^0-9]/);
    return (new Date(a[0], a[1] - 1, a[2]).getTime() / 1000).toFixed(0);
}

function objectArrayHasItemWithAttr(arr, attr, value) {
    if (!arr || arr.length === 0) return false;
    for (let i = 0; i < arr.length; i++) {
        if (arr[i][attr] === value) {
            return true;
        }
    }
    return false;
}
</script>

<style scoped>

.submit-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 18px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 56px;
    width: 100%;
    background-color: #00ba57 !important;
    text-align: center;
    vertical-align: middle;
    padding: 0 !important;
    margin: 0 !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

/deep/ .v-btn__content {
    margin: 0 !important;
    line-height: 1.1;
}
.preview-button {
    color: #ffffff !important;
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 19px !important;
    text-transform: none !important;
    box-shadow: none !important;

    height: 70px;
    width: 90%;
    background-color: #00ba57 !important;
    text-align: center;
    padding: 0 30px !important;

    border-width: 1px;
    border-radius: 100px;
    border-color: transparent;
    border-style: solid;
}

/deep/ h1 {
    font-size: 65px;
    font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
    line-height: 1;
    font-weight: 700;
    color: #000000;
}

.v-list {
    max-height: 600px;

    &__tile {
        background: #FFF !important;
    }
}

/deep/ .v-list__tile {
    background: #FFF !important;
}

@media (max-width: 960px) {
    /deep/ h1 {
        font-size: 54px;
    }
}

/deep/ h2, h3 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

/deep/ .v-tabs__item {
    justify-content: left;
    text-transform: none;
    font-size: 16px;
    font-weight: 500;
}

/deep/ .v-tabs__item--active {
    font-weight: 700;
}

.agent-actions a {
    color: black;
    margin-right: 40px;
}

.agent-actions a img {
    margin-right: 5px;
    width: 21px;
    height: 21px;
    vertical-align: -5px;
}

.agent-actions a.disabled {
    color: grey;
}

.agent-actions a.disabled img {
    color: grey;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
}

/deep/ table.v-table tbody td,
/deep/ table.v-table tbody th {
    height: 110px;
}

/deep/ table.v-table tbody td,
/deep/ table.v-table thead th {
    font-size: 14px;
}

/deep/ table.v-table thead td,
/deep/ table.v-table tbody td,
/deep/ table.v-table thead th,
/deep/ table.v-table tbody th {
    padding: 0 5px;
}

/deep/ table.v-table tbody td {
    cursor: pointer;
}

/deep/ table.v-table tbody td:not(:nth-child(1)),
/deep/ table.v-table tbody td:first-child {
    /*white-space: pre-line;*/
}

/deep/ table.v-table thead tr th {
    /*max-width: fit-content;*/
    white-space: nowrap;
}

/deep/ table.v-table thead tr th.sortable {
    white-space: nowrap;
}

.ins-logo-container {
    white-space: nowrap !important;
}

.ins-logo {
    max-height: 32px;
    max-width: 118px;
    vertical-align: middle;
}

.link {
    font-size: 14px;
    font-weight: bold;
    text-decoration: unset !important;
    color: #FF5252 !important;
}

/deep/ .filters .v-input__slot,
/deep/ .filters .v-input__control,
/deep/ .filters .v-text-field {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
}

/deep/ .mh-0-important input {
    min-height: 0 !important;
}

/deep/ .with-count .v-tabs__item {
    position: relative !important;
}

/deep/ .with-count .v-tabs__item .with-count__num {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 0;
    top: 0;
    background-color: #00ba57;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    font-size: 12px;
    transform: translate(5px, 0px);
}

/deep/ tr.not-active {
    background: #eee;
}

/deep/ .prolongation-table .v-input input,
/deep/ .prolongation-table .v-text-field .v-input__append-inner,
/deep/ .prolongation-table .v-select__slot,
/deep/ .prolongation-table .v-select__selections,
/deep/ .prolongation-table .v-select__selection--comma {
    background-color: inherit;
}

/deep/ .prolongation-table .v-text-field .v-label--active {
    display: none;
}

</style>


<style scoped lang="scss">

.v-menu__content {
    border-radius: 14px;
    border: 1px solid #e9eceb;
}

.breadcrumb-new {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 36px;
    font-size: 16px;
    color: #6b7a72;
}

.breadcrumb-new a {
    color: #00BA57;
    text-decoration: none;
    font-weight: 500;
    transition: opacity .2s;
}
.breadcrumb-new a:hover { opacity: .7; }
.breadcrumb-new span { color: #c8d4cc; }

@keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
}
.breadcrumb-new { animation: fadeUp .4s ease both; }

.top-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 80px;
}

.page-title {
    span {
        color: #00BA57;
    }

    animation: fadeUp .6s ease both;
}

.reward-badge {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    animation: fadeUp .6s ease both;

    @media (max-width: 960px) {
        align-items: flex-start;
    }
}

.reward-label {
    font-size: 18px;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: #6b7a72;

    @media (max-width: 960px) {
        font-size: 14px;
    }
}

.reward-amount {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 20px;

    span {
        font-family: 'SFPro', 'Arial', 'sans-serif';
        font-size: 32px;
        font-weight: 700;
        color: #111814;
        line-height: 1;
    }
}

.reward-amount .currency {
    font-size: 20px;
    color: #00BA57;
}

.control-bar {
    display: grid;
    grid-template-columns: 1fr auto;
    gap: 12px;
    align-items: stretch;
    animation: fadeUp 1s ease both;

    @media (max-width: 960px) {
        grid-template-columns: unset;
        grid-template-rows: 1fr auto;
    }
}

.search-cluster {
    display: flex;
    gap: 10px;
    background: #ffffff;
    border: 1.5px solid #e2e8e4;
    border-radius: 16px;
    padding: 6px 6px 6px 20px;
    align-items: center;
    transition: border-color .2s, box-shadow .2s;
    box-shadow: 0 2px 12px rgba(0,0,0,.04);
}
.search-cluster:focus-within {
    border-color: #00BA57;
    box-shadow: 0 0 0 4px rgba(29, 185, 84, 0.18);
}

/* text search */
.text-search {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}
.text-search svg { color: #b0bfb6; flex-shrink: 0; }
.text-search input {
    border: none;
    outline: none;
    width: 100%;
    font-family: 'SFPro', 'Arial', 'sans-serif';
    font-size: 15px;
    color: #111814;
    background: transparent;
}
.text-search input::placeholder { color: #b0bfb6; }

/* buttons cluster */
.btn-cluster {
    display: flex;
    gap: 8px;
    align-items: center;
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: 'SFPro', 'Arial', 'sans-serif';
    font-weight: 400;
    font-size: 15px;
    border: none;
    cursor: pointer;
    border-radius: 28px;
    padding: 0 22px;
    height: 52px;
    white-space: nowrap;
    transition: transform .15s, box-shadow .15s, background .15s;
}
.btn:active { transform: scale(.97); }

.btn-primary {
    background: #00BA57;
    color: #fff;
    box-shadow: 0 4px 16px rgba(29,185,84,.3);
}
.btn-primary:hover {
    background: #01af52;
    box-shadow: 0 6px 24px rgba(29,185,84,.45);
}

.btn-outline {
    background: #ffffff;
    color: #111814;
    border: 1.5px solid #e2e8e4;
    box-shadow: 0 2px 8px rgba(0,0,0,.04);
}
.btn-outline:hover {
    border-color: #00BA57;
    color: #00BA57;
    background: #f0faf4;
}

.btn-search-width {
    width: 165px;
}

/* Products dropdown hint */
.products-btn-wrap {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    position: relative;
}
.products-link {
    font-size: 12px;
    color: #00BA57;
    text-decoration: none;
    font-weight: 500;
    padding-right: 7px;
    transition: opacity .2s;
    position: absolute;
    bottom: -20px;
}
.products-link:hover { opacity: .7; }

.search-block {
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0,0,0,0.05);
    overflow: hidden;

    &__header {
        padding: 24px;
    }

    &__body {
        padding: 0 24px 24px;
    }
}

.filters-block {
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px;
        cursor: pointer;
        transition: all 0.4s ease-in-out;

        &:hover {
            background-color: #e7e7e7;
        }

        .arrow-up-down {
            color: #000000;
            font-size: 20px;
            transition: transform .4s ease-in-out;

            user-select: none;
        }

        .rotate {
            transform: rotate(-180deg);
        }
    }

    &__body {
        padding: 14px;
    }

    .v-expansion-panel {
        box-shadow: unset;
        margin: 0;

        &__body {
            p {
                margin-bottom: 0;
            }
        }
    }
}

.policy-list-table {
    animation: fadeUp 1.2s ease both;
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0,0,0,0.05);
    overflow: hidden;

    .flex {
        padding: 10px;
    }

    &__header {
        padding: 14px;
        display: flex;

        @media (max-width: 850px) {
            overflow-x: scroll;
        }

        .download-excel-button {
            margin-left: auto;
        }
    }

    &__body {
        padding: 14px;
    }
}

.table-block {
    display: flex;
    justify-content: center;
    align-items: center;
}

.status-text {
    border-radius: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    padding: 4px 8px;
    width: 100%;
}

.status-success {
    color: #FFFFFF;
    background-color: #00BA57;
}

.status-confirmed {
    color: #FFFFFF;
    background-color: #3e72b7;
}

.status-draft {
    color: #FFFFFF;
    background-color: #C3C3C3;
}

.table-row {
    position: relative;
}

.table-actions {
    position: sticky;
    right: 0;
    z-index: 5;

    /*min-width: 60px;
    padding: 0 12px;*/

    background:
        linear-gradient(to left, #fff 80%, rgba(255,255,255,0));

    /*box-shadow: inset 6px 0 8px rgba(0,0,0,0.08);*/
}

.reward-loading-hint {
    display: flex;
    align-items: center;
    gap: 8px;
    color: #00BA57;
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 34px;
}

/*.table-actions {
    position: sticky;
    display: flex;
    justify-content: center;
    align-items: center;

    right: 12px;

    transform: translateX(8px);

    opacity: 0;
    pointer-events: none;

    transition: all 0.2s ease;
}

.table-row:hover .table-actions {
    opacity: 1;
    transform: translateX(0);
    pointer-events: auto;
}*/

</style>

<style>
.policy-type-select {
    input {
        display: none;
    }

    .v-select__selections {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/PolicyList.vue